import { render, staticRenderFns } from "./LeadWidgets.vue?vue&type=template&id=1a3d4cd4&scoped=true&"
import script from "./LeadWidgets.vue?vue&type=script&lang=js&"
export * from "./LeadWidgets.vue?vue&type=script&lang=js&"
import style0 from "./LeadWidgets.vue?vue&type=style&index=0&id=1a3d4cd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3d4cd4",
  null
  
)

export default component.exports